import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'nonMediaType';

export class NonMediaType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
